// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductGridContainer, {
    ProductGridContainerStyle,
    useProductGridContainerContext,
} from "@pacific/App/Components/Product/ProductGridTemplate";
import { color, mergeWithCss, xScreen } from "@pacific/XDL/Utilities";
import React, { FC, useState } from "react";
import { css } from "styled-components";

export interface ProductListContainerStyles extends ProductGridContainerStyle {
    contentWrapper?: InjectableCss;
}

const productListContainerStyle: ProductListContainerStyles = {
    container: {
        css: css`
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: row;
            max-width: unset;
            min-width: unset;
            width: 100%;
            ${xScreen("lte", "md")} {
                max-width: unset;
            }
            ${xScreen("lte", "sm")} {
                max-width: unset;
            }
            ${xScreen("lte", 678)} {
                flex-wrap: wrap;
            }
        `,
    },
    info: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding: 0px 22px 0 12px;
        `,
    },
    addToCartActions: {
        css: css`
            margin-bottom: 0;
        `,
    },
    contentWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            height: 100%;
            gap: 48px;
        `,
    },
};

const ProductListContainer = ({
    children,
    extendedStyles,
    ...otherProps
}: {
    children: Array<React.ReactElement>;
    extendedStyles?: ProductGridContainerStyle;
    [key: string]: any;
}) => {
    const [styles] = useState(() => mergeWithCss(productListContainerStyle, extendedStyles));
    return (
        <ProductGridContainer extendedStyles={styles} {...otherProps}>
            {children}
        </ProductGridContainer>
    );
};

export default ProductListContainer;

const ContentWrapper: FC = ({ children, ...otherProps }) => {
    const {
        styles: { contentWrapper },
    } = useProductGridContainerContext() as any;

    return (
        <StyledWrapper {...otherProps} {...contentWrapper}>
            {children}
        </StyledWrapper>
    );
};

ProductListContainer.ContentWrapper = ContentWrapper;
ProductListContainer.Image = ProductGridContainer.Image;
ProductListContainer.Info = ProductGridContainer.Info;
ProductListContainer.PriceAndActions = ProductGridContainer.PriceAndActions;
ProductListContainer.AddToCartActions = ProductGridContainer.AddToCartActions;
ProductListContainer.AddToList = ProductGridContainer.AddToList;
ProductListContainer.AddToList = ProductGridContainer.Price;
ProductListContainer.AddToList = ProductGridContainer.Availability;
